import React from 'react';
import { Button } from 'react-bootstrap';

const MobileFooter = () => {
  return (
    <div>
      <span className='d-block text-center'>
        For more help contact us <a href="/Contact">here</a>

      </span>
      <footer style={{ backgroundColor: '#31572C', color: 'white', padding: '10px 10px', textAlign: 'center', position: 'relative' }}>
        
        <div style={{ fontSize: '14px', fontWeight: 'bold'}}>
          Greater Austin Muslim Relief Committee (GAMRC)
        </div>



        <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: '5px' }}>
          <span style={{ fontSize: '12px', textAlign: 'center', marginBottom: '5px' }}>
            Nueces Mosque • ICGA • ICRR • ICBC • ICLT • GIC • QCIC • Al-Noor MCC • ICHC
          </span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'ROW', gap: '10px' }}>
          <Button
            href="/ApplyForHelp"
            style={{ backgroundColor: "#ABC399", borderColor: "#31572C", width: "100%", color: 'black',  fontSize: '18px', fontWeight: 'bold', fontFamily: 'Lora',height: '100%' }}
            target=""
          >
            Apply For Help
          </Button>

          <Button
            href="/PayZakatHere"
            style={{ backgroundColor: "#42226D", borderColor: "#42226D", width: "100%", fontSize: '18px', fontWeight: 'bold', fontFamily: 'Lora',height: '100%' }}
          >
             Pay Zakat Here
          </Button>
        </div>
      </footer>
    </div>
  );
};

export default MobileFooter;
